export default __webpack_public_path__ + "static/media/clockGray.95d28474.svg";